import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=33801e3f&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=33801e3f&prod&scoped=true&lang=css"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=33801e3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33801e3f",
  null
  
)

export default component.exports